import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { BuilderHero } from './components/Hero'
import { BuilderCustomBuild } from './components/CustomBuild'
import { BuilderFeatureSet } from './components/FeatureSet'
import { BuilderApplications } from './components/Applications'
import classes from './ConnectorBuilder.module.scss'

export default function ConnectorBuilderPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'Connector Builder'} />
      <Container grid>
        <BuilderHero />
        <BuilderCustomBuild />
        <BuilderFeatureSet />
        <BuilderApplications />
      </Container>
    </DefaultPageLayout>
  )
}
